import {
  compose,
  filter,
  invertObj,
  map,
  pick,
  prop,
  reduce,
  slice,
  toLower,
  trim,
  values,
  without,
} from 'ramda';

import { clear, compact, path, unprefix } from '../../../../helpers/compact';
import { DocumentType } from '../../../../types/document';
import { REGION_NATIONAL } from '../../../../types/filters';
import {
  PRISMIC_TO_TYPE_REGION,
  toRegionPrismic,
  toRegionType,
} from '../../mapping/region';
import { deprecatedPageEntity } from './internal';

const territories = values(
  pick(
    without([REGION_NATIONAL.NATIONAL], values(REGION_NATIONAL)),
    invertObj(PRISMIC_TO_TYPE_REGION)
  )
);

const createSection = ({ main_contact, title, contact_list = [] }) =>
  clear({
    main: prop('id', main_contact),
    title,
    contacts: filter(Boolean, map(path('contact.id'), contact_list)),
  });

const createTerritory = ({ twitter, slices = [], ...pressSection }) =>
  compact({
    twitter,
    sections: clear([
      createSection(unprefix('press', pressSection)),
      ...map(
        ({ primary: { title, main_contact }, items: contact_list }) =>
          createSection({ title, main_contact, contact_list }),
        slices
      ),
    ]),
  });

const getCode = compose(trim, toLower, slice(0, 3));

const processContactPage = (data) =>
  compact({
    uid: DocumentType.CONTACT_PAGE,
    type: DocumentType.CONTACT_PAGE,
    territories: {
      national: {
        [REGION_NATIONAL.NATIONAL]: createTerritory(
          unprefix(getCode(toRegionPrismic(REGION_NATIONAL.NATIONAL)), data)
        ),
      },
      regional: reduce(
        (acc, name) => ({
          ...acc,
          [toRegionType(name)]: createTerritory(unprefix(getCode(name), data)),
        }),
        {},
        territories
      ),
    },
  });

export const ContactPageEntity = deprecatedPageEntity(
  DocumentType.CONTACT_PAGE,
  {
    processStrategy: (entity) => processContactPage(prop('data', entity)),
  }
);
